import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useDeleteTrainerFile = (trainerId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: number) => trainerFilesApi.deleteFile(trainerId, fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_FILES(trainerId) });
    },
  });
};
